import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 11C14.4852 11 16.5 8.98528 16.5 6.5C16.5 4.01472 14.4852 2 12 2C9.51472 2 7.5 4.01472 7.5 6.5C7.5 8.98528 9.51472 11 12 11Z",
      stroke: "currentColor",
      "stroke-width": "1.75",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.17351 13.5377C10.0353 13.928 10.9923 14.1452 12 14.1452C13.0077 14.1452 13.9647 13.928 14.8265 13.5377L14.8299 13.5361C15.4248 13.2668 15.7226 13.1319 15.888 13.0853C16.0603 13.0367 16.1602 13.0191 16.3387 13.0058C16.5105 12.993 16.6391 13.0028 16.8963 13.0224C17.0015 13.0304 17.0943 13.0417 17.1822 13.0576C18.5892 13.3123 19.6904 14.413 19.9452 15.8196C20 16.1224 20 16.4855 20 17.2116V17.2117V19.1721V19.1721C20 19.812 20 20.1319 19.8754 20.3762C19.7659 20.5912 19.591 20.7659 19.376 20.8755C19.1315 21 18.8115 21 18.1714 21H5.82855C5.18851 21 4.86848 21 4.62401 20.8755C4.40897 20.7659 4.23414 20.5912 4.12456 20.3762C4 20.1318 4 19.812 4 19.1721V17.2117C4 16.4856 4 16.1224 4.05483 15.8196C4.30957 14.413 5.41077 13.3123 6.81781 13.0576C6.90571 13.0417 6.99854 13.0304 7.10374 13.0224C7.36091 13.0028 7.4895 12.993 7.66127 13.0058C7.83981 13.0191 7.93966 13.0367 8.11197 13.0853C8.27742 13.1319 8.57518 13.2667 9.17006 13.5361L9.17008 13.5361L9.17351 13.5377Z",
      stroke: "currentColor",
      "stroke-width": "1.75",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }